import moment from 'moment';

export function newSubscriptionStartDate(
    isSubscriptionUpgrade,
    currentSubscription,
    lastSubscription) {
    if (currentSubscription === null ||
        currentSubscription.subscription_type_id === 4 ||
        isSubscriptionUpgrade) {
        return moment();
    } else {
        let lastSubscriptionEndDate = moment(lastSubscription.end_date);
        return (lastSubscriptionEndDate.isSameOrBefore(moment()) ? moment() : lastSubscriptionEndDate).add(1, 'days');
    }
}

export function newSubscriptionEndDate(
    subscriptionDuration,
    isSubscriptionUpgrade,
    currentSubscription,
    lastSubscription
) {
    if (currentSubscription === null ||
        currentSubscription.subscription_type_id === 4 ||
        isSubscriptionUpgrade) {
        return moment().add(subscriptionDuration + 1, 'days');
    } else {
        let lastSubscriptionEndDate = moment(lastSubscription.end_date);
        return (lastSubscriptionEndDate.isSameOrBefore(moment()) ? moment() : lastSubscriptionEndDate).add(subscriptionDuration + 1, 'days');
    }
}
